import { Button, Modal } from "react-bootstrap";

interface DeleteModalProps {
  show: boolean;
  onHide: () => void;
  onDelete: () => void;
  message?: string;
}

const DeleteModal = ({ show, onHide, onDelete, message }: DeleteModalProps) => {
  return (
    <Modal show={show} onHide={onHide}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Deletion</Modal.Title>
      </Modal.Header>
      <Modal.Body>{message || "Are you sure you want to delete?"}</Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Cancel
        </Button>
        <Button variant="danger" onClick={onDelete}>
          Delete
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default DeleteModal;
